document.addEventListener('DOMContentLoaded', () => {
	const mobileMenu = document.getElementById('mobile_menu');
	const mobileMenuButtons = {
		open: document.getElementById('mobile_menu_open'),
		close: document.getElementById('mobile_menu_close')
	}

	if (!mobileMenu || !mobileMenuButtons.open || !mobileMenuButtons.close) return;

	for (let [name, element] of Object.entries(mobileMenuButtons)) {
		element.addEventListener('click', () => {
			mobileMenu.classList.toggle('active');
		});
	}
});
